export default "__VITE_ASSET__Dmob_vmL__"